var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15588 0.899902H26.8448C27.115 0.899902 27.3337 1.069 27.3337 1.27744C27.3337 1.48589 27.115 1.65476 26.8448 1.65476H1.15588C0.885659 1.65476 0.666992 1.48612 0.666992 1.27744C0.666992 1.06877 0.885659 0.899902 1.15588 0.899902ZM7.82256 6.04821H26.8448C27.115 6.04821 27.3337 6.2173 27.3337 6.42575C27.3337 6.6342 27.115 6.80306 26.8448 6.80306H7.82256C7.55234 6.80306 7.33367 6.6342 7.33367 6.42575C7.33367 6.2173 7.55234 6.04821 7.82256 6.04821ZM26.8448 11.1965H1.15588C0.885659 11.1965 0.666992 11.3654 0.666992 11.5741C0.666992 11.7825 0.885659 11.9516 1.15588 11.9516H26.8448C27.115 11.9516 27.3337 11.7825 27.3337 11.5741C27.3337 11.3654 27.115 11.1965 26.8448 11.1965ZM7.82256 16.3446H26.8448C27.115 16.3446 27.3337 16.5135 27.3337 16.7221C27.3337 16.9308 27.115 17.0999 26.8448 17.0999H7.82256C7.55234 17.0999 7.33367 16.9308 7.33367 16.7221C7.33367 16.5135 7.55234 16.3446 7.82256 16.3446Z",
    fill: "#01015F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.d4e5ee65f64dea403034e1b89bb3a205.svg";
export { ForwardRef as ReactComponent };